<template>
  <v-dialog width="1000" v-model="showAttachmentForm">
    <v-card>
      <v-card-title class="secondary white--text">
        <span> Company Request {{ companyRequestNo }} </span>

        <v-spacer></v-spacer>

        <v-btn icon @click="resetForm(), (showAttachmentForm = false)">
          <v-icon class="white--text">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-2">
        <v-form
          ref="companyRequestAttachmentForm"
          v-if="showAttachmentForm"
          v-model="isValid"
        >
          <v-row class="my-0">
            <v-col cols="5" class="Form-Columns">
              <InputField
                type="text"
                label="Document Type *"
                required
                :rules="[(val) => !!val || 'Document type is Required!']"
                hide-details="auto"
                v-model="companyRequestDetails.document_name"
                :error-messages="formErrors.document_type"
                @input="delete formErrors.document_type"
              />
            </v-col>

            <v-col cols="4">
              <v-file-input
                label="Document *"
                accept="image/x-png,image/jpg,image/jpeg,application/pdf"
                :rules="[
                  (file) =>
                    !file ||
                    file.size < 2e6 ||
                    'File size should be less than 2 MB!',
                ]"
                outlined
                dense
                hide-details="auto"
                v-model="companyRequestDetails.attachment"
                :error-messages="formErrors.attachment"
                @change="checkFileFormat($event), delete formErrors.attachment"
              />
            </v-col>
            <v-col cols="3" class="d-flex justify-end">
              <v-btn
                color="primary"
                depressed
                :disabled="!isValid || !companyRequestDetails.attachment"
                @click="submitDocument"
              >
                Submit
              </v-btn>

              <v-btn
                class="ml-3"
                color="secondary"
                depressed
                @click="resetForm"
              >
                Reset
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-text>
        <AgGridVue
          style="width: 100%; height: calc(90vh - 320px)"
          class="ag-theme-alpine"
          id="myGrid"
          :columnDefs="headers"
          :context="context"
          @grid-ready="onGridReady"
          :defaultColDef="defaultColDef"
          :grid-options="gridOptions"
          :suppressDragLeaveHidesColumns="true"
          :rowData="allRowList"
        ></AgGridVue>

        <v-col v-if="totalItems > 0" cols="12" class="d-flex justify-end">
          <Pagination
            :pageNo="pageNo"
            :totalItems="totalItems"
            :pageSize="itemsPerPage"
            @itemsPerPageChange="itemsPerPageChanged"
            @prevPage="prevPage"
            @nextPage="nextPage"
          />
        </v-col>
      </v-card-text>

      <v-divider></v-divider>
    </v-card>
  </v-dialog>
</template>

<script>
import InputField from "@/components/FormBaseComponents/InputField.vue";
import MultiSelect from "@/components/FormBaseComponents/MultiSelect.vue";
import SelectField from "@/components/FormBaseComponents/SelectField.vue";
import { AgGridVue } from "ag-grid-vue";
import companyRequestAttachementButton from "@/components/AgGridComponents/companyRequestAttachementButton.vue";
import Pagination from "@/components/General/Pagination.vue";
import {
  generateBlobData,
  download,
  getFileNameFromUrl,
} from "@/utils/functions.js";
export default {
  components: {
    InputField,
    AgGridVue,
    SelectField,
    MultiSelect,
    companyRequestAttachementButton,
    Pagination,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    companyRequestID: {
      type: [Number, null],
      default: null,
    },
    companyRequestNo: {
      type: [String, null],
      default: null,
    },
  },
  watch: {
    value(val) {
      if (val) {
        if (this.editMode) {
        }
        this.getCompanyRequestDocumentList();
      } else {
        this.resetForm();
      }
    },
  },
  computed: {
    showAttachmentForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    context() {
      return { parentComponent: this };
    },
    offset() {
      return this.itemsPerPage * (this.pageNo - 1);
    },
  },
  data() {
    return {
      formErrors: {},
      allRowList: [],
      isValid: true,
      generateBlobData: generateBlobData,
      download: download,
      isTextInput: false,
      pageNo: 1,
      itemsPerPage: 20,
      totalItems: 0,

      companyRequestDetails: {},
      defaultColDef: {
        resizable: true,
      },
      gridOptions: {
        onGridSizeChanged: () => {
          this.resizeGrid();
        },

        suppressRowClickSelection: true,
        suppressDragLeaveHidesColumns: true,
        enableCellTextSelection: true,
        tooltipShowDelay: 0,
        rowHeight: 35,
      },
      headers: [
        {
          headerName: "Document Name",
          field: "document_name",
          minWidth: 80,
        },
        {
          headerName: "Document",
          field: "attachment_name",
          minWidth: 120,
        },
        {
          headerName: "Actions",
          field: "actions",
          cellRendererFramework: "companyRequestAttachementButton",
          pinned: "right",
          minWidth: 100,
        },
      ],
    };
  },

  methods: {
    getFileNameFromUrl,

    checkFileFormat(event) {
      if (event) {
        const name = event.name;
        const lastDot = name.lastIndexOf(".");
        const ext = name.substring(lastDot + 1);
        let allowed = /(\jpg|\jpeg|\pdf|\png)$/i;
        if (!allowed.exec(ext)) {
          this.$nextTick(() => {
            this.companyRequestDetails.attachment = null;
            this.$bus.$emit("showToastMessage", {
              message: "This file format is not supported!",
              color: "error",
            });
          });
          return false;
        } else {
          return true;
        }
      }
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.resizeGrid();
    },
    resizeGrid() {
      if (this.gridOptions && "api" in this.gridOptions) {
        setTimeout(() => {
          this.gridOptions.api.sizeColumnsToFit();
        }, 100);
      }
    },
    itemsPerPageChanged(e) {
      this.pageNo = 1;
      this.itemsPerPage = e;
      this.getCompanyRequestDocumentList();
    },
    prevPage() {
      this.pageNo--;
      this.getCompanyRequestDocumentList();
    },
    nextPage() {
      this.pageNo++;
      this.getCompanyRequestDocumentList();
    },
    viewItemDoc(data) {
      window.open(data.attachment, "_blank");
    },
    async downloadDoc(data) {
      this.$bus.$emit("showLoader", true);

      try {
        const response =
          await this.$api.companyRequestDoc.getDownloadDocumentsBlobObject(
            data.id
          );

        this.$bus.$emit("showLoader", false);

        const contentType = response.data.type;

        const fileExtension = response.data.type.split("/")[1];
        const fileName = this.getFileNameFromUrl(data.attachment);
        this.generateBlobData(
          response.data,
          `${this.getFileNameFromUrl(data.attachment).split(".")[0]}`,
          contentType
        );
      } catch (err) {
        console.error(err);
        this.$bus.$emit("showLoader", false);
      }
    
    },
    deleteDocument(data) {
      if (confirm(`Are you sure you want to delete ${data.document_name} ?`)) {
        this.$bus.$emit("showLoader", true);
        this.$api.companyRequestDoc
          .deleteCompanyRequestDocument(data.id)
          .then((response) => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: "Document Deleted successfully!",
              color: "success",
            });

            this.getCompanyRequestDocumentList();
          })
          .catch((err) => {
            console.error(err);
            this.$bus.$emit("showLoader", false);
          });
      }
    },

    submitDocument() {
      const formData = new FormData();
      formData.append(
        "document_type",
        this.companyRequestDetails.document_name
      );

      formData.append("attachment", this.companyRequestDetails.attachment);

      if (this.companyRequestID) {
        formData.append("company_request", this.companyRequestID);
      }

      this.$api.companyRequestDoc
        .companyRequestAttachment(formData)
        .then((res) => {
          this.$bus.$emit("showToastMessage", {
            message: "Document Uploaded successfully!",
            color: "success",
          });

          this.getCompanyRequestDocumentList();

          this.resetForm();
        })
        .catch((err) => {
          this.$bus.$emit("showLoader", false);
          this.$bus.$emit("showToastMessage", {
            message: "Couldn't Create Document",
            color: "error",
          });
          this.formErrors = err.data;
        });
    },

    getCompanyRequestDocumentList(params = {}) {
      this.$bus.$emit("showLoader", true);
      params = {
        offset: this.offset,
        limit: this.itemsPerPage,
        company_request: this.companyRequestID,
        ...params,
        ...this.filters,
      };

      this.$api.companyRequestDoc
        .getCompanyRequestAttachmentList(params)
        .then((res) => {
          this.allRowList = res.data;
          this.totalItems = res.count;

          this.$bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },

    resetForm() {
      if (this.$refs.companyRequestAttachmentForm) {
        this.$refs.companyRequestAttachmentForm.reset();
      }
      this.companyRequestDetails = {};
    },
  },
};
</script>
